import { getCensorRatingById, getGenresByIds } from '@vista/omnichannel-components-domain';
import { FilmImageMediaType } from '../../components/film/image/types/media-type';
import { getActorsForFilm, getDirectorsForFilm } from '../film-utils';
import { getFilmCdnUrlForMedia } from '../get-film-cdn-url-for-media';
import { mapCastAndCrewMembersToPersonSchema } from './cast-and-crew-member';
import { mapCensorRatingToRatingSchema } from './censor-rating';
import { mapMinutesToDurationSchema } from './duration';
/**
 * Maps a @vista-digital/ocapi-types Film entity to a schema.org/Movie type.
 */
export const mapFilmToMovieSchema = (film, i18n, url) => {
    var _a;
    const posterUrl = getFilmCdnUrlForMedia(film, FilmImageMediaType.Poster, { width: 200 });
    const actors = getActorsForFilm(film);
    const directors = getDirectorsForFilm(film);
    const genres = getGenresByIds(film.genreIds);
    const censorRating = film.censorRatingId ? getCensorRatingById(film.censorRatingId) : undefined;
    return {
        '@type': 'Movie',
        name: i18n.translatable(film.title),
        url: url,
        image: posterUrl,
        datePublished: film.releaseDate,
        dateCreated: film.releaseDate,
        actor: mapCastAndCrewMembersToPersonSchema(actors, i18n),
        director: mapCastAndCrewMembersToPersonSchema(directors, i18n),
        duration: mapMinutesToDurationSchema(film.runtimeInMinutes),
        abstract: i18n.translatable(film.synopsis),
        genre: i18n.translatable((_a = genres[0]) === null || _a === void 0 ? void 0 : _a.name),
        contentRating: censorRating
            ? mapCensorRatingToRatingSchema(censorRating, i18n, film.censorRatingNote)
            : undefined
    };
};
